<template>
  <div>
    <v-row class="align-center pa-2 pl-3 border-b--thin">
      <template v-if="!showAllBoxesMode">
        <transition name="slide-x-reverse-transition" mode="out-in">
          <!-- ITEMS -->
          <div v-if="selectedCount === 0" key="1" class="c-flex-r align-center subheading">
            <!-- select menu -->
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-check-box-multiple-outline</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="selectAll">
                  <v-list-item-title>Select all</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectPage">
                  <v-list-item-title>Select page</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectNone">
                  <v-list-item-title>Select none</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-btn
            depressed
            class="mr-2 foreground--text"
            color="text"
            @click="addItem">
              <v-icon>add</v-icon>
              <div class="ml-1">
                Add item
              </div>
            </v-btn>
            
            <v-btn
            depressed
            outlined
            class="mr-2"
            @click="addCustomRow">
              <div class="ml-1">
                Add custom row
              </div>
              
              <v-menu offset-y open-on-hover transition="slide-y-transition">
                <template v-slot:activator="{ on }">
      
                  <v-icon v-on="on" color="text" size="20" class="ml-3">mdi-information-outline</v-icon>
          
                </template>
                <v-card outlined class="elevation-0 pa-6" max-width="350px">
                  <div class="text-center mb-4 title">
                    <v-icon size="30" color="text">mdi-information-outline</v-icon>
                    Custom rows
                  </div>
                  <div class="">
                    Add a custom row (like in excel). <br />
                    Each cell will be completely editable. Can be used for things like a comment, something random like 'Label samples' or anything you dont want to define in Corex as a new inventory definition. These items are not tracked.
                  </div>
                </v-card>
              </v-menu>
            </v-btn>
            

          </div>

          <!-- selected count -->
          <div v-if="selectedCount > 0" key="2" class="c-flex-r align-center subheading">
            <v-btn icon class @click="selected = {}">
              <v-icon color="color1">close</v-icon>
            </v-btn>
            <div class="text-sans font-weight-bold">
              <span>&nbsp;{{ selectedCount }}</span>
              selected
            </div>
            <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
            <span class="icon--text ml-2">|</span>
            <v-btn icon @click="onDelete">
              <v-icon>delete_outline</v-icon>
            </v-btn>
            <!-- select menu -->
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-check-box-multiple-outline</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="selectAll">
                  <v-list-item-title>Select all</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectPage">
                  <v-list-item-title>Select page</v-list-item-title>
                </v-list-item>
                <v-list-item @click="selectNone">
                  <v-list-item-title>Select none</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </transition>
      </template>

      <v-spacer></v-spacer>
      <v-btn icon @click="localSingleMode = !localSingleMode">
        <v-icon>{{ localSingleMode ? 'mdi-group' : 'mdi-ungroup' }}</v-icon>
      </v-btn>
      
    </v-row><!-- -->

    <template v-if="localSingleMode">
      <!-- TABLE OVERFLOW -->
      <div style="overflow: auto; flex: 1; position: relative;">
        <table
        :class="['final-table compact th-no-padding lines-b lines-r full-width', {'hover pointer': selectedCount !== 0}]"
        >

          <colgroup ref="colgroup1">
            <col v-for="(item, i) in columnSchema" :key="item.name" :width="columnWeights[i] || '150px'">
          </colgroup>

          <tr>

            <template v-for="(item, i) in columnSchema">
              <!-- item.code || item.name = item.code for default rows, item.name for json rows -->
              <c-table-header
              :key="item.name"
              :title="item.name"
              :code="item.code || item.name"
              :class="[{'sticky' : i === 0}]"
              :filters="filters"
              showHandle
              @startColDrag="startColDrag(i, $event)"
              @onClick="clickSortHeader">
              </c-table-header>
            </template>

            <!--
            <c-table-header
              title="Name"
              code="name"
              :filters="filters"
              showHandle
              @onClick="clickSortHeader"
              @startColDrag="startColDrag(0, $event)"
            ></c-table-header>
            <c-table-header 
            title="Box count" 
            code="working"
            :filters="filters" 
            @onClick="clickSortHeader">
            </c-table-header>
            <c-table-header 
            title="Quantity per box" 
            code="working"
            :filters="filters" 
            @onClick="clickSortHeader">
            </c-table-header>
            <c-table-header
              title="Total Quantity"
              code="quantity"
              :filters="filters"
              @onClick="clickSortHeader"
            ></c-table-header>
            <c-table-header
              title="Total weight"
              code="weight"
              :filters="filters"
              @onClick="clickSortHeader"
            ></c-table-header>
            <th></th>
            <th></th>
            -->
          </tr>

          <tr>
            <template v-for="(item, i) in columnSchema">
              <td v-if="item.name === 'Name'" :class="i === 0 ? 'sticky' : ''" :key="item.name">
                <v-text-field
                v-model="filters.search.id"
                placeholder="Search..."
                hide-details
                clearable
                class="crx-box-input"
                solo></v-text-field>
              </td>
              <td v-else :key="item.name" :class="i === 0 ? 'sticky' : ''"></td>
            </template>
          </tr>

          <list-row
            v-for="item in paginatedArray"
            vmode="single"
            :key="item.tempID"
            :columnSchema="columnSchema"
            :item="item"
            :reserved="(savedInputs.find(row => row.id === item.id) || {}).quantity"
            :inventoryView="inventoryView"
            :mergeMap="mergeMap"
            :selected="selected"
            @checkRow="checkRow(item)"
            @click.native="clickRow(item)"
          ></list-row>
        </table>
      </div>

      <!-- PAGINATION -->
      <c-pagination-client
      :page="page"
      :paginationLength="paginationLength"
      :paginatedArray="paginatedArray"
      :rowsPerPage.sync="rowsPerPage"
      @updatePageNumber="updatePageNumber"
      @goToFirstPage="goToFirstPage"
      @goToPreviousPage="goToPreviousPage"
      @goToNextPage="goToNextPage"
      @goToLastPage="goToLastPage">
      </c-pagination-client>
      <!-- PAGINATION -->
    </template>

    <template v-if="!localSingleMode">
      <group-card 
      :itemSource="itemMap"
      :savedInputs="savedInputs"
      :mergeMap="mergeMap"
      :showAllBoxesMode="showAllBoxesMode"
      :boxOrderIDMap="boxOrderIDMap"
      :inventoryView="inventoryView"
      @checkRow="checkRow"
      :selectedMain="selected"></group-card>
    </template>

    <!-- DIALOGS -->
    <select-inventory-item-dialog 
    ref="selectItemDialog" 
    :exceptions="inventoryExceptions"
    :mergePayload="mergePayload"
    ></select-inventory-item-dialog>

  </div>
</template>

<script>
import GroupCard from './grouped'
import ListRow from "./list-row";
import ListController from "@/mixins/ListController";
import DragTableHeaders from '@/mixins/DragTableHeaders';
import SelectInventoryItemDialog from "@/components/dialogs/select-inv-item/Dialog";
import { SETTINGS as STATIC_SETTINGS } from '@/js/shared/static-strings.js'

export default {
  props: {
    itemSource: {
      type: Array
    },
    savedInputs: null,
    mergeMap: null,
    mergePayload: null,
    inventoryView: null,
    activeBox: null,
    boxOrderIDMap: null,
    singleMode: {
      type: Boolean,
      default: true
    }
  },
  components: {
    GroupCard,
    ListRow,
    SelectInventoryItemDialog
  },
  mixins: [ListController, DragTableHeaders],
  data() {
    return {
      localSingleMode: this.singleMode,
      columnWeights: {
        0: '300px', 
        1: '80px',
        3: '200px'
      }
    }
  },
  watch: {
    itemSource: {
      immediate: true,
      handler (items) {
        this.items = items
      }
    },
    items (nv) {
      this.$emit('update:itemsSource', nv)
    },
    activeBox (nv) {
      // when switching boxes reset what was selected from the old box
      this.selected = {}
    }
  },
  computed: {
    columnSchema () {
      let schema = JSON.parse(this.$store.state.settings.dict[STATIC_SETTINGS.SALES_COLUMN_SCHEMA])
      return schema
    },
    inventoryExceptions() {
      return []
      return this.items.map(item => {
        if (item.inventory_id) {
          return item.inventory_id;
        } else {
          return this.mergeMap[item.id];
        }
      });
    },
    showAllBoxesMode () {
      // In this mode all items will be shown, and in each row it will show which box the item is in
      return this.activeBox === null
    },
    itemMap () {
      var map ={
        normal_items: {},
        custom_items: {}
      }
      this.items.forEach(item => {
        if (item.json_data) {
          // for custom items
          var name = item.json_data.name || 'UNSET'
          if (!map.custom_items[name]) {
            map.custom_items[name] = {
              name: name,
              isCustomRow: true,
              items: [item]
              }
          } else {
            map.custom_items[name].items.push(item)
          }
        } else {
          // For normal items
          if (!map.normal_items[item.inventory_item_id]) {
            map.normal_items[item.inventory_item_id] = {
              definition: item.definition,
              items: [item]
              }
          } else {
            map.normal_items[item.inventory_item_id].items.push(item)
          }
        }
      })
      return map
    }
  },
  methods: {
    clickRow(item) {
      if (this.selectedCount > 0) {
        this.checkRow(item);
      }
    },
    addItem() {
      this.$refs.selectItemDialog
        .open()
        .then(selectedItem => {
          console.log('We are here')
          var copy = JSON.parse(JSON.stringify(selectedItem));
          // copy.quantity_available = copy.quantity
          copy.quantity = 0;
          if (!copy.isPseudo) {
            copy.inventory_id = copy.id;
            copy.id = undefined;
          }
          copy.box = this.activeBox
          copy.quantity_per_box = 0
          copy.box_count = 0
          copy.weight = 0
          copy.custom_columns = {}
          this.$emit('addItem', copy)
        })
        .catch(() => {
          // console.log('rejected')
        });
    },
    addCustomRow () {
      var newItem = {
        json_data: {},
        quantity: 0,
        // for sure
        box: this.activeBox,
        quantity_per_box: 0,
        box_count: 0,
        weight: 0,
        custom_columns: {}
      }
      this.$emit('addItem', newItem)
    },
    onDelete() {
      var selectedRows = this.getSelectedRows();
      var idArray = selectedRows.reduce((a, i) => {
        a.push(i.tempID);
        return a;
      }, []);
      this.$emit('onDelete', idArray)
    }
  }
}
</script>